import { environment } from "../../../environments/environment";
import Amplify, { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "aws-amplify/lib/API/types";

export const CRUD = {
  CREATE: "create",
  LIST: "list",
  GET: "get",
  UPDATE: "update",
  DELETE: "delete",
};
/**
 * AWS Provider for Driver Attendance
 */
export class AwsAppServiceProvider {
  /**
   * TAG name for this Page
   */
  private TAG = "AwsAppServiceProvider";

  private QUERY_KEY = {
    GET_APP_LIST: CRUD.GET + environment.dbPrefix + "CpRnFcmToken",
    CREATE_APP: CRUD.CREATE + environment.dbPrefix + "CpRnFcmToken",
    UPDATE_APP: CRUD.UPDATE + environment.dbPrefix + "CpRnFcmToken",
  };
  constructor() {
    // console.log('[INFO] ' + this.TAG + ' - AWS : Mode : ', environment.mode);
    // console.log(
    //   '[INFO] ' + this.TAG + ' - AWS : AWS Config : ',
    //   environment.awsConfig
    // );
    // Amplify.configure(environment.awsConfig);

    let myAppConfig = environment.myAppConfig;
    Amplify.configure(myAppConfig);
  }
  /************************************************************
   * Queries for Driver Attendance
   ************************************************************/

  private GetAppFCMToken =
    `query ` +
    this.QUERY_KEY.GET_APP_LIST +
    `($rn_number: String!) {
  ` +
    this.QUERY_KEY.GET_APP_LIST +
    `(rn_number:$rn_number) {
          rn_number
          fcm_token
          email
          user_name
          created_on
          updated_on
  }
  }`;

  // fcm_token: String,
  // user_name: String,
  // email: String,
  // created_on: AwsDate,
  // updated_on: AwsDate
  // $created_on: String,
  // $updated_on: String
  // created_on: $created_on
  // updated_on: $updated_on

  private createFCMToken =
    `mutation ` +
    this.QUERY_KEY.CREATE_APP +
    `($rn_number: String!,
      $fcm_token: String,
  $user_name: String,
  $email: String,
  $created_on: AWSDateTime,
  $updated_on: AWSDateTime
  ) {
` +
    this.QUERY_KEY.CREATE_APP +
    `(input:{
      rn_number: $rn_number
      fcm_token: $fcm_token
      user_name: $user_name
      email: $email
      created_on: $created_on
      updated_on: $updated_on
}) {
    rn_number
    fcm_token
    user_name
    email
    created_on
    updated_on
}

}`;

  listApplicationServices(rnNumber: string): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(this.GetAppFCMToken, {
          rn_number: rnNumber,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result: any) => {
          resolve(result.data[this.QUERY_KEY.GET_APP_LIST]);
          console.log("PUSH NOTIFICATION DATA", result);
        })
        .catch((error) => {
          console.log(
            "[ERROR] " + this.TAG + " listApplicationServices - onError:",
            JSON.stringify(error)
          );
          reject(error);
        });
    });
    return promise;
  }

  applicationFCMTokeCreate(tokenDB): Promise<any> {
    console.log(":::TOKEN DB", tokenDB);
    let promise = new Promise((resolve, reject) => {
      var mypromise = API.graphql(
        graphqlOperation(this.createFCMToken, {
          rn_number: tokenDB.rn_number,
          fcm_token: tokenDB.fcm_token,
          user_name: tokenDB.user_name,
          email: tokenDB.email,
          created_on: tokenDB.created_on,
          updated_on: tokenDB.updated_on,
        })
      ) as Promise<GraphQLResult>;
      mypromise
        .then((result) => {
          resolve(result.data[this.QUERY_KEY.CREATE_APP]);
        })
        .catch((error) => {
          console.log("applicationFCMTokeCreate", error);
          reject(error);
        });
    });
    return promise;
  }
}
